var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.933333C0 0.417868 0.407014 0 0.909091 0H5.98708C6.22818 0 6.45942 0.0983331 6.6299 0.273367L9.73373 3.45997C9.90422 3.635 10 3.8724 10 4.11993V13.0667C10 13.5821 9.59299 14 9.09091 14H0.909091C0.407014 14 0 13.5821 0 13.0667V0.933333Z",
    fill: "#518FF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 4.12012H6.89648L9.99994 6.53334V4.12012Z",
    fill: "#518FF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 4.12012H6.89648L9.99994 6.53334V4.12012Z",
    fill: "#383838",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7327 3.45971L6.6291 0.273346C6.45863 0.0983257 6.22742 0 5.98633 0V3.18636C5.98633 3.70179 6.39331 4.11962 6.89535 4.11962H9.99895C9.99895 3.87211 9.90318 3.63473 9.7327 3.45971Z",
    fill: "#92BBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50803 10.4342C5.66391 10.4342 5.79036 10.5609 5.79036 10.7171C5.79036 10.8733 5.66391 11 5.50803 11H2.28233C2.12645 11 2 10.8733 2 10.7171C2 10.5609 2.12645 10.4342 2.28233 10.4342H5.50803Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71767 9.22213C6.87355 9.22213 7 9.34883 7 9.50503C7 9.66123 6.87355 9.78793 6.71767 9.78793H2.28233C2.12645 9.78793 2 9.66123 2 9.50503C2 9.34883 2.12645 9.22213 2.28233 9.22213H6.71767Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71767 8.21207C6.87355 8.21207 7 8.33877 7 8.49497C7 8.65117 6.87355 8.77787 6.71767 8.77787H2.28233C2.12645 8.77787 2 8.65117 2 8.49497C2 8.33877 2.12645 8.21207 2.28233 8.21207H6.71767Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71767 7C6.87355 7 7 7.1267 7 7.2829C7 7.43909 6.87355 7.56579 6.71767 7.56579H2.28233C2.12645 7.56579 2 7.43909 2 7.2829C2 7.1267 2.12645 7 2.28233 7H6.71767Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailIcon);
export default __webpack_public_path__ + "static/media/detailIcon.1a1b70b72a8ac7dea4bd13134358748c.svg";
export { ForwardRef as ReactComponent };